module.exports = __webpack_public_path__ + "static/downloable/formato-solicitud-pago-de-herencia.c1ebf7e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/formatos/formato-solicitud-pago-de-herencia.pdf
// module id = +cQU
// module chunks = 1